/* eslint-disable @typescript-eslint/no-explicit-any */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';

import * as Types from 'src/graphql/schema';

export type IAgreementApproveMutationVariables = Types.Exact<{
  escrowId: Types.Scalars['ID']['input'];
}>;

export type IAgreementApproveMutation = {
  __typename?: 'Mutation';
  agreementApprove?: {
    __typename?: 'AgreementApprovePayload';
    success: boolean;
    errors?: Array<string> | null;
    escrow?:
      | {
          __typename?: 'ContinuityEscrow';
          id: string;
          status: Types.EscrowStatusEnum;
          agreement: { __typename?: 'Agreement'; id: string };
        }
      | {
          __typename?: 'SaasEscrow';
          id: string;
          status: Types.EscrowStatusEnum;
          agreement: { __typename?: 'Agreement'; id: string };
        }
      | {
          __typename?: 'SoftwareEscrow';
          id: string;
          status: Types.EscrowStatusEnum;
          agreement: { __typename?: 'Agreement'; id: string };
        }
      | null;
  } | null;
};

export const AgreementApproveDocument = {
  kind: 'Document',
  definitions: [
    {
      kind: 'OperationDefinition',
      operation: 'mutation',
      name: { kind: 'Name', value: 'agreementApprove' },
      variableDefinitions: [
        {
          kind: 'VariableDefinition',
          variable: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
          type: { kind: 'NonNullType', type: { kind: 'NamedType', name: { kind: 'Name', value: 'ID' } } },
        },
      ],
      selectionSet: {
        kind: 'SelectionSet',
        selections: [
          {
            kind: 'Field',
            name: { kind: 'Name', value: 'agreementApprove' },
            arguments: [
              {
                kind: 'Argument',
                name: { kind: 'Name', value: 'input' },
                value: {
                  kind: 'ObjectValue',
                  fields: [
                    {
                      kind: 'ObjectField',
                      name: { kind: 'Name', value: 'escrowId' },
                      value: { kind: 'Variable', name: { kind: 'Name', value: 'escrowId' } },
                    },
                  ],
                },
              },
            ],
            selectionSet: {
              kind: 'SelectionSet',
              selections: [
                { kind: 'Field', name: { kind: 'Name', value: 'success' } },
                { kind: 'Field', name: { kind: 'Name', value: 'errors' } },
                {
                  kind: 'Field',
                  name: { kind: 'Name', value: 'escrow' },
                  selectionSet: {
                    kind: 'SelectionSet',
                    selections: [
                      { kind: 'Field', name: { kind: 'Name', value: 'id' } },
                      { kind: 'Field', name: { kind: 'Name', value: 'status' } },
                      {
                        kind: 'Field',
                        name: { kind: 'Name', value: 'agreement' },
                        selectionSet: {
                          kind: 'SelectionSet',
                          selections: [{ kind: 'Field', name: { kind: 'Name', value: 'id' } }],
                        },
                      },
                    ],
                  },
                },
              ],
            },
          },
        ],
      },
    },
  ],
} as unknown as DocumentNode<IAgreementApproveMutation, IAgreementApproveMutationVariables>;
